// @flow

type Props = {
  promoCode: Object,
  context: {
    currentUser?: Object,
    selectedPlan?: Object,
    type: 'checkout' | 'redeem',
  },
};

const validatePlanType = ({ promoCode, context }: Props): [boolean, ?string] => {
  const { currentUser, selectedPlan, type } = context;

  if (!promoCode?.metadata?.planType) return [true, null];

  switch (type) {
    case 'checkout':
      if (!selectedPlan?.metadata?.planType) {
        return [false, 'missingPlanType'];
      }
      if (promoCode.metadata.planType !== selectedPlan.metadata.planType) {
        return [false, 'invalidPlanType'];
      }
      break;

    case 'redeem':
      if (!currentUser?.entitlement?.planType) {
        return [false, 'missingPlanType'];
      }
      if (promoCode.metadata.planType.toLowerCase() !== currentUser.entitlement.planType.toLowerCase()) {
        return [false, 'invalidPlanType'];
      }
      break;

    default:
      break;
  }

  return [true, null];
};

const validateEmail = ({ promoCode, context }: Props): [boolean, ?string] => {
  const { currentUser, type } = context;
  if (!promoCode?.constraints?.emailContains) return [true, null];
  const { emailContains } = promoCode.constraints;

  switch (type) {
    case 'checkout' || 'redeem':
      if (!currentUser) {
        return [false, 'requiresUserEmail'];
      }
      if (!currentUser?.email.match(emailContains)) {
        return [false, 'invalidEmail'];
      }
      break;

    default:
      break;
  }
  // helper to reset promoCode if user signout & email no longer avail
  // setEmailCodeValidated(true);
  return [true, null];
};

const promoCodeValidators = ({ promoCode, context }: Props): $ReadOnlyArray<mixed> => {
  const validateFuncs = [validatePlanType, validateEmail];

  for (const validate of validateFuncs) {
    const [valid, errorCase] = validate({ promoCode, context });

    if (!valid) {
      switch (errorCase) {
        case 'missingPlanType':
          return [false, 'Error_Promocode_MissingPlanType'];
        case 'invalidPlanType':
          return [false, 'Error_Promocode_InvalidPlanType'];
        case 'requiresUserEmail':
          return [false, 'Error_Promocode_RequiresEmail'];
        case 'invalidEmail':
          return [false, 'Error_Promocode_InvalidEmail'];
        default:
          return [false, 'Error_Promocode_Invalid'];
      }
    }
  }

  return [true, null];
};

export default promoCodeValidators;
